import { useEffect, useRef } from 'react';

/**
 * Observes a video element and starts loading + playing it
 * only when it enters the viewport. Pass the returned ref to
 * the <video> element you want to lazy-load.
 */
export default function useLazyVideo(rootMargin = '200px') {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = ref.current;
    if (!video) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          if (video.readyState === 0) {
            video.load();
          }
          video.play().catch(() => {
            // autoplay blocked – fine, video will stay paused
          });
          observer.unobserve(video);
        }
      },
      { rootMargin }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, [rootMargin]);

  return ref;
}
